import dayjs from "dayjs";
import { useAccount } from "./useAccount";
import { getJWT } from "~/helpers/auth";
const API_URL: string = import.meta.env.VITE_API_URL;

export const useReconnectAliexpress = () => {
  const { account } = useAccount();
  const emptyReturn = {
    handleReconnect: () => {},
    tokenExpiresAt: null,
    showReconnectBanner: false as const,
  };

  const tokenExpiresAt = account?.aliexpress_expires_at
    ? new Date(account.aliexpress_expires_at)
    : null;

  if (!tokenExpiresAt) return emptyReturn;

  const minDaysFromNow = 4;
  const daysFromNow = dayjs(tokenExpiresAt).diff(dayjs(), "days");
  if (daysFromNow > minDaysFromNow) return emptyReturn;

  const handleReconnect = () => {
    const jwt = getJWT();
    if (!jwt) return;
    window.open(
      API_URL + `/aliexpress/oauth/?token=${encodeURIComponent(jwt)}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return {
    handleReconnect,
    tokenExpiresAt,
    showReconnectBanner: true as const,
  };
};
